
import XButton from 'vux/src/components/x-button/index.vue'

import {Api} from "../utils/api"
import {Md5} from "../utils/crypt"

export default {
name: 'out-invoice',
components: {
XButton
},

data () {
return {
showProcess: false,
invoiceTitle:"",
invoiceNum:"",
orderFee:"",
orderNum:"",
canInvoice: false,
}
},
created () {
this.invoiceTitle = decodeURIComponent(this.$route.query["invoiceTitle"] || "")
this.invoiceNum = decodeURIComponent(this.$route.query["invoiceNum"] || "")
let of = this.$route.query["orderFee"]
this.orderFee = parseFloat(of)
this.orderNum = this.$route.query["orderNum"]
let token = this.$route.query["token"]
if (!token || token != Md5(`${of}-${this.orderNum}-ydtmed19`)) {

this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">身份验证错误!!</span>`,
confirmText:"返回修改",
showCancelButton:false,
async onConfirm(){
window.location.href = "http://www.medcircle.cn/meetingapp/sign/order"
}
})
} else {
this.canInvoice = true
}


if (!this.invoiceTitle || !this.orderFee || !this.orderNum) {
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">开票信息错误!!</span>`,
confirmText:"返回修改",
showCancelButton:false,
async onConfirm(){
window.location.href = "http://www.medcircle.cn/meetingapp/sign/order"
}
})
}

},

methods: {
async handleSubmit() {
this.$vux.loading.show({text: '获取授权地址中'});

try {
let res = await Api('GetInvoiceUrlThirdPart', {
Prefix: "YDT",
OrderNum: this.orderNum,
RedirectUrl: "http://www.medcircle.cn/meetingapp/sign/order",
OrderFee: this.orderFee,
InvoiceTitle: this.invoiceTitle,
InvoiceNum: this.invoiceNum,

})
this.$vux.loading.hide()
if (res.data.Status == "unauthorized" && res.data.Url) {
window.location.href = res.data.Url
}else {
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">您已授权，发票正在开取中！请稍后</span>`,
confirmText:"返回订单",
cancelText:"留在此页",
async onConfirm(){
window.location.href = "http://www.medcircle.cn/meetingapp/sign/order"
}
})
}



} catch (err) {
this.$vux.loading.hide()
this.$vux.toast.show({
text: '获取发票授权地址失败，请稍后再试！',
type: 'text',
width: '3rem'
})

}
},
async handleCancel() {
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">是否取消开取发票？</span>`,
confirmText:"取消开票",
cancelText:"留在此页",
async onConfirm(){
window.location.href = "http://www.medcircle.cn/meetingapp/sign/order"
}
})
}
}
}
